<div class="feedback-container" [class.offline]="!isOnline()">
  <div class="feedback-row">
    <ion-accordion-group>
      <ion-accordion value="first">
        <ion-item slot="header" color="primary" class="narrow-accordion">
          <ion-icon name="help-buoy-outline" slot="start"></ion-icon>
          <ion-label>Feedback</ion-label>
        </ion-item>

        <ion-item slot="content" lines="none" (click)="callHotline()">
          <ion-icon name="call-outline" slot="start"></ion-icon>
          <ion-label>Appeler la hotline</ion-label>
        </ion-item>

        <ion-item slot="content" lines="none" (click)="openSupportChat()">
          <ion-icon name="chatbubbles-outline" slot="start"></ion-icon>
          <ion-label>Signaler via Chat</ion-label>
        </ion-item>
      </ion-accordion>
    </ion-accordion-group>
  </div>
</div>
